<template>
    <div :class="`selectUsers ycFormItem control-${mode}`">
        <Input
            :value="usersStr"
            :class="{
                'selectUsers-readonly': $isReadonly(canEdit, propsObj),
                'selectUsers-disabled': $isDisabled(canEdit, propsObj)
            }"
            :placeholder="$showPlaceholder(canEdit, propsObj) ? `请选择${propsObj._name}` : ''"
            :disabled="!finalCanEdit"
            :clearable="finalCanEdit"
            @on-focus="handleShowModal()"
            @on-clear="handleClear"
        />
        <!-- 搜索选择框 -->
        <Modal
            class="selectUsers-modal"
            width="800"
            v-model="usersModal"
            title="选择成员"
            :footer-hide="true"
            :mask-closable="true"
            @click.native.stop="0"
        >
            <div class="selectUsers-list">
                <!-- 选项项 -->
                <div class="selectUsers-list-select">
                    <span>已选择{{ propsObj._multiple ?  `(${val.length}个)` : "" }}：</span>
                    <span
                        v-for="(userItem, userIndex) in val"
                        :key="userIndex"
                        class="selectUsers-list-select-item"
                    >
                        <span class="selectUsers-list-select-item-name dsh-ellipsis">{{ userItem.realname || userItem.mobile }}</span>
                        <Icon
                            class="selectUsers-list-select-item-delete dsh-margin-left5"
                            type="md-close"
                            @click="deleteUser(userItem, userIndex, val)"
                        ></Icon>
                    </span>
                </div>

                <!-- 搜索框 -->
                <div class="selectUsers-list-search">
                    <Input class="selectUsers-list-search-item" v-model="searchName" placeholder="搜索成员" clearable @on-change="handleSearch" />
                    <Select
                        class="selectUsers-list-search-item"
                        v-model="department"
                        clearable
                        placeholder="请选择部门"
                        @on-change="dapartmentChange"
                    >
                    <Option
                        v-for="departmentItem in departmentList"
                        :key="departmentItem._id"
                        :value="departmentItem._id"
                    >
                        {{departmentItem.name}}
                    </Option>
                    </Select>
                </div>

                <!-- 列表 -->
                <template v-if="userList.length">
                    <div
                        v-for="(userItem, index) in userList"
                        :key="userItem._id"
                        class="selectUsers-list-item"
                        :style="{paddingRight: (index+1)%3 == 0 ? 0 : '10px'}"
                        @click="handleChange(userItem)"
                    >
                        <div class="selectUsers-list-item-normal" :class="userItem | isActive(val)">
                            <span class="label dsh-ellipsis">{{ userItem.realname || userItem.mobile }}</span>
                            <img class="avatar" :src="$imageResize(userItem.avatarurl || person,  {m: 'lfit',  w: 40, h: 40})" alt="">
                        </div>
                    </div>
                </template>
                <div v-else class="selectUsers-list-nodata">
                    <p>暂无数据</p>
                </div>

                <!-- 高级选项 -->
                <template v-if="propsObj._highSearch">
                    <p class="selectUsers-list-high">高级选项</p>
                    <div
                        class="selectUsers-list-item"
                        v-for="userItem in hightUsers"
                        :key="userItem._id"
                        @click="handleChange(userItem)"
                    >
                        <div class="selectUsers-list-item-normal" :class="userItem | isActive(val)">
                            <span class="label dsh-ellipsis">{{ userItem.realname || userItem.mobile }}</span>
                            <img class="avatar" :src="$imageResize(userItem.avatarurl || person,  {m: 'lfit',  w: 40, h: 40})" alt="">
                        </div>
                    </div>
                </template>
            </div>

            <!-- 分页 -->
            <div class="selectUsers-page">
                <Page
                    :total="total"
                    :current="currentPage"
                    :page-size="pagesize"
                    size="small"
                    :show-total="true"
                    @on-change="changePage"
                />
            </div>
        </Modal>
    </div>
    <!-- <div v-else class="dsh-ellipsis" style="padding-left:5px;">
        <span v-for="item in val" :key="item.id">
            <img
                :src="item.avatarurl || $imageSrcMap.system.boy"
                class="selectUsers-userIcon"/>
            <span class="selectUsers-userName">
                {{ formatUserName(item) }}
            </span>
        </span>
    </div> -->
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "selectUsers",
        mixins: [controlMixin],
        inject: ["companyId", "appId"],
        props: {},
        data () {
            return {
                person: this.$imageSrcMap.system.boy,
                usersModal: false,
                searchName: "", // 搜索名字
                userList: [],

                total: 0,
                currentPage: 1,
                pagesize: 18,

                hightUsers: [
                    {
                        _id: "dyn_myself",
                        realname: "当前用户"
                    }
                ],
                department: "",
                departmentList: []
            };
        },
        computed: {
            val: {
                get () {
                    return this.value[this.propsObj._key] ? this.value[this.propsObj._key].filter(item => !!item) : [];
                },
                set (val) {
                    this.value[this.propsObj._key] = val;

                    this.change();
                }
            },
            usersStr  () {
                return this.val.map(user => user.realname || user.mobile).join("、");
            }
        },
        created () {
            // this.init(); // 移动到打开弹框时获取
        },
        methods: {
            init () {
                this.getUserList();
                this.getDepartmentList();
            },
            getUserList (departmentId) {
                let search = {};
                if (this.searchName && this.searchName !== "") {
                    search["realname"] = {
                        "$regex": `.*${this.searchName}.*`, $options: "i"
                    };
                } else {
                    delete search["realname"];
                }
                this.$https({
                    url: {
                        module: "company",
                        name: "userIndex"
                    },
                    params: {
                        fields: "realname mobile avatarurl",
                        search: search,
                        department: departmentId,
                        pagination: {
                            page: this.currentPage,
                            pagesize: this.pagesize
                        }
                    },
                    callback: data => {
                        this.total = data.total;
                        this.userList = data.list;
                    }
                });
            },
            getDepartmentList () {
                this.$https({
                    url: {
                        module: "company",
                        name: "compDepartIndex"
                    },
                    params: {
                        fields: "name",
                        pagination: {
                            page: 1,
                            pagesize: 500
                        }
                    },
                    callback: data => {
                        this.departmentList = data.list;
                    }
                });
            },
            handleShowModal () {
                if (this.finalCanEdit) {
                    this.init();
                    this.usersModal = true;
                    this.department = "";
                }
            },
            handleClear () {
                this.val = [];
            },
            deleteUser (item, index, list) {
                list.splice(index, 1);
                this.val = [...list];
            },
            handleChange (userItem) {
                if (this.propsObj._multiple) {
                    if (this.val.some(user => user._id === userItem._id)) {
                        this.val = this.val.filter(user => user._id !== userItem._id);
                    } else {
                        this.val = [...this.val, userItem];
                    }
                } else {
                    this.val = [userItem];
                }
            },

            handleSearch () {
                this.currentPage = 1;
                this.getUserList();
            },
            changePage (page) {
                this.currentPage = page;
                this.getUserList();
            },
            formatUserName (item) {
                // 格式化成员名称
                return item && (item.name || item.realname || item.mobile || item);
            },
            dapartmentChange (id) {
                // if (id) {
                //     this.getUserList(id)
                // } else {
                //     this.getUserList
                // }
                this.getUserList(id);
            }
        },
        filters: {
            isActive (item, list) {
                return list.some(o => o._id === item._id) ? "selectUsers-list-item-active" : "";
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/controls/sheet/selectUsers.vue